export const freezeAppFlawValue = (value) => {
  if (value && typeof value === 'object' && !Object.isFrozen(value)) {
    Object.values(value).forEach(freezeAppFlawValue);
    Object.freeze(value);
  }

  return value;
};
